module.exports = __webpack_public_path__ + "static/WEDDING E&M-477-beab4ecf5f900bfe058961c71f82133d.jpg";